/* eslint-disable max-params */
export const getActiveHeader = (headers) => headers
  .filter((h) => h.display === true)
  .map((h) => h.sNo);

export const getInActiveHeader = (headers) => headers
  .filter((h) => h.display === false)
  .map((h) => h.sNo);

export const getSNoToHeaderMap = (headers) => Object.fromEntries(headers.map((h) => [h.sNo, h]));

export const getPreferenceOrder = (headers) => headers.map((h) => h.sNo);

export const getOptionsForMultiSelect = (preferenceOrder,
  headerMap, activeHeader, inactiveHeader) => preferenceOrder.map((sNo) => {
  const h = headerMap[sNo];
  const rv = {};
  rv.key = h.sNo;
  rv.value = h.label;
  if (activeHeader.indexOf(sNo) > -1) {
    rv.selected = true;
  } else if (inactiveHeader.indexOf(sNo) > -1) {
    rv.selected = false;
  } else {
    rv.selected = h.display;
  }
  rv.rank = h.sNo;
  return rv;
});
